module.exports = __webpack_public_path__ + "static/img/gd.b4245f8b.png";